(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/wallet-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/wallet-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const _svs$oddset_kambi$com = svs.oddset_kambi.components.kambiWidgetUtils.constants,
  WIDGET_ID = _svs$oddset_kambi$com.WIDGET_ID,
  WIDGET_TAG = _svs$oddset_kambi$com.WIDGET_TAG;
class WalletWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.walletWidget, WIDGET_TAG.walletWidget, {
      betslipMain: [{
        widgetId: WIDGET_ID.walletWidget,
        order: 'bottom'
      }]
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.WalletWidgetDefinition', WalletWidgetDefinition);

 })(window);